import React from 'react';
const ClientProjects = () => <div className='p-6'><h1 className='text-2xl font-bold'>My Projects</h1><p className='text-slate-500'>Coming soon...</p></div>;
export default ClientProjects;
